import React from 'react'
import { Box, Typography } from '@mui/material'
import { INTERAX_COLORS, INTERAX_TYPOGRAPHY } from '../../../../constants/colors'

interface AssessmentModalProgressSliderProps {
  currentQuestionIndex: number
  totalQuestions: number
  stepLabel?: string
}

export const AssessmentModalProgressSlider: React.FC<AssessmentModalProgressSliderProps> = ({
  currentQuestionIndex,
  totalQuestions,
  stepLabel
}) => {
  const progress = Math.round((currentQuestionIndex / totalQuestions) * 100)

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <Typography
          sx={{
            ...INTERAX_TYPOGRAPHY.body3,
            color: INTERAX_COLORS.thunderGrey,
            letterSpacing: '0.08em',
            textTransform: 'uppercase',
            fontWeight: 600
          }}
        >
          {stepLabel ? stepLabel : `QUESTION ${currentQuestionIndex} OF ${totalQuestions}`}
        </Typography>
        <Typography
          sx={{
            ...INTERAX_TYPOGRAPHY.body3,
            color: INTERAX_COLORS.sun,
            fontWeight: 600
          }}
        >
          {progress}% COMPLETE
        </Typography>
      </Box>

      <Box
        sx={{
          height: '4px',
          backgroundColor: INTERAX_COLORS.thunderGrey20,
          borderRadius: '2px',
          overflow: 'hidden'
        }}
      >
        <Box
          sx={{
            width: `${progress}%`,
            height: '100%',
            backgroundColor: INTERAX_COLORS.sun,
            borderRadius: '2px',
            transition: 'width 0.3s ease-in-out'
          }}
        />
      </Box>
    </Box>
  )
}
